export default __webpack_public_path__ + "static/essence-white-small-039cc05bd6cb02160b585a706d869bf0.png";